<script lang="ts">
    import YouTube from "$lib/components/episodes/YouTube.svelte";
    import Parameters from "$lib/components/episodes/Parameters.svelte";
    import EpisodeContent from "$lib/components/episodes/EpisodeContent.svelte";
    import Meta from "$components/meta/MetaEpisode.svelte";
    import Heading from "$components/layout/page/Heading.svelte";
    import type { PageData } from "./$types";
    import type { SvelteComponent } from "svelte";
    import { get_pattern } from "$lib/utilities";

    export let data: PageData;

    let w: number;
    let video_player: SvelteComponent;
</script>

<svelte:window bind:innerWidth={w} />

{#key data.episode}
    <Meta episode={data.episode} location="in-revue" />
{/key}
<EpisodeContent round_top>
    <svelte:fragment slot="content">
        {#if data.episode.in_revue}
            <YouTube
                code={data.episode.in_revue}
                context="episode"
                bind:this={video_player}
            />
        {:else}
            <div class="no_video" style:background-image={get_pattern()}>
                <div class="title">Not Available Yet</div>

                <div class="text">
                    Please subscribe to our
                    <a
                        href="https://youtube.com/craftroulette"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        YouTube channel</a
                    > so you don't miss out.
                </div>
            </div>
        {/if}
        {#if data.episode.project && data.episode.colors && data.episode.element && data.episode.random}
            <Parameters
                project={data.episode.project}
                colors={data.episode.colors}
                element={data.episode.element}
                random={data.episode.random}
            />
        {/if}
        <div class="stuff">
            {#if data.episode?.episode_number && data.episode?.episode_number > 183}
                <Heading>Members Show</Heading>
                <p>
                    If you like the Card Showcase on In Revue, you'll love our weekly
                    Members Show! Mary and a special guest get together and talk about a
                    selection of contributions each week.
                </p>

                <p>
                    <a
                        href="/members/members-show-{data.episode?.episode_number}"
                        data-sveltekit-reload>Click here to login and watch!</a
                    >
                </p>
            {/if}
            <Heading>In Revue:</Heading>
            <p>
                A follow-up show that airs every Tuesday on our <a
                    href="http://youtube.com/craftroulette"
                    target="_blank"
                    rel="noopener noreferrer">YouTube Channel</a
                >.
            </p>
        </div>
    </svelte:fragment>
</EpisodeContent>

<style>
.no_video {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;
  border-radius: 2rem 2rem 0 0;
  overflow: hidden;
  border-bottom: 1px solid var(--dots);
  aspect-ratio: 16/5;
  padding: 1.5rem;
  color: var(--title);
}
.no_video .title {
  color: transparent;
  font-family: "open sans", sans-serif;
  font-weight: bold;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: var(--title);
  text-shadow: 2px 2px var(--secondary);
  font-size: 2rem;
  margin-bottom: 1.5rem;
}
.no_video .text {
  font-size: 0.9rem;
  color: var(--title);
}

.stuff {
  padding: 1.5rem 3rem;
}

@media (max-width: 650px) {
  .stuff {
    padding: 1rem;
  }
}
</style>
